export default __webpack_public_path__ + "static/media/inideia.36cf25f6.png";